module.exports = __webpack_public_path__ + "img/workRight.83350281.png";